/** Teks sub-bagian "Kalimat tunggu suara" di "Gaya & aturan Jenna" (id/en). */
export interface AssistantWaitPhrasesText {
	title: string;
	description: string;
	placeholder: string;
	add: string;
	remove: string;
	restoreDefault: string;
}

const id: AssistantWaitPhrasesText = {
	title: "Kalimat tunggu suara",
	description:
		"Saat menunggu jawaban, asisten suara hanya mengucapkan salah satu kalimat ini. Netral dan tidak menyebut sistem atau bertanya ke pihak lain. Berlaku di sesi suara berikutnya.",
	placeholder: "Tambah kalimat, mis. Tunggu sebentar ya",
	add: "Tambah",
	remove: "Hapus {word}",
	restoreDefault: "Kembalikan bawaan",
};

const en: AssistantWaitPhrasesText = {
	title: "Voice waiting sentences",
	description:
		"While waiting for the answer, the voice assistant says only one of these sentences. Keep them neutral: no mention of a system or of asking someone else. Applies to the next voice session.",
	placeholder: "Add a sentence, e.g. Tunggu sebentar ya",
	add: "Add",
	remove: "Remove {word}",
	restoreDefault: "Restore defaults",
};

export const assistantWaitPhrasesTexts = { id, en } as const;
